import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Link, withRouter } from 'react-router-dom';
import * as Business from '../../utils/business';
import UpdatePassword from '../../pages/User/UpdatePassword'
import * as Http from '../../http'

class UserInfo extends Component {

  state = {
    isShowingUserMenu: false
  };

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  render() {
    let { isShowingUserMenu } = this.state;
    const currentUser = Http.getCurrentUserInfo()

    return (
      <div className="user-wrapper">
        <div className="user">
          <img src={require('../../assets/icons/avatar.png')} alt={Business.getAccountFullName()}
            style={{
              width: 61,
              height: 61,
              marginRight: 10
            }}
          />
          <div className="userinfo">
            <div className="username">
              {Business.getAccountFullName()}
            </div>
            <div className="title">{Business.getCurrentRoleGroupName()}</div>
          </div>
          {/* <span
            onClick={() => this.setState({ isShowingUserMenu: !this.state.isShowingUserMenu })}
            className={cx("pe-7s-angle-down collapse-arrow", {
              active: isShowingUserMenu
            })}></span> */}
        </div>
        {/* <Collapse in={isShowingUserMenu}>
          <ul className="nav user-nav">
            <li className={this.isPathActive('/report/change-password') ? 'active' : null}>
              <Link to="" onClick={() => this.updateUserRef.show(currentUser)}>Change password</Link>
            </li>
          </ul>
        </Collapse>
        <UpdatePassword ref={ref => this.updateUserRef = ref} /> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.Auth.user
});

export default withRouter(connect(mapStateToProps)(UserInfo));


// WEBPACK FOOTER //
// ./src/components/SideBar/UserInfo.js